import rules from "../../Data/Rules"
import Verification from "../Steps/Verification"

// URL 
// Example: http://localhost:8080/?Portal=FILE&Type=1867&Document=BA_Integrity&Client=NBL1North
// Parameters:
// Portal=FILE as this is the File Portal
// Type - the Codes Table Code_id
// Document - Match a value in the Documents Constant below
// Client - Match a value in the Logo constant below

let step1
const Documents = {
    BA_Integrity: "BA Integrity Gambling & Match Fixing Certificate",
    Annual_Update: "Annual Update 2023 Certificate",
    BA_Approval: "BA Approval Notice",
    Coach_Cert: "Coaching Course Certificate",
    Passport: "Passport or proof of Citizenship",
    Clearance: "Proof Notification of Clearance",
    U16_Indeminty: "U16 Signed Indeminity Form",
    Profile: "Profile Picture"
}
const Logo = {
    NBL1South: 'NBL1South.png',
    NBL1North: 'NBL1North.png',
    NBL1East: 'NBL1East.png',
    NBL1Central: 'NBL1Central.png',
    NBL1West: 'NBL1West.png',
    NBL1: 'NBL1.png',
    BIGV: 'BigVLogoNew.png',
    OUG: 'logo.png',
}


// Load Models
const LoadModel = async (Passed) => {
    let result = {
        Portal: 'File Upload',
        MainColor: "#f5924c",
        Logo: require(`../../assets/${Passed.Logo}`),
        Title: `<h2>Load a copy of your<br>${Passed.Desc} <br>to your Profile</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            {
                stepno: 2,
                title: 'File Details',
                valid: true,
                information: `Select the file to upload as ${Passed.Desc}`,
                Model: {},
                Schema: {
                    File: {
                        type: 'file',
                        label: 'File to Upload',
                        multiple: false,
                        outlined: true,
                        multiple: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        col: 12,
                        rules: [rules.requiredMsg('File to Upload is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: Number(Passed.Type),
                                Action: "SingleDesc",
                                Description: Passed.Desc,
                            }
                        },
                    },
                },
            },
            // Step 3
            {
                stepno: 3,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for loading your file - you can find a copy on the OwnUrGoal App under Profile -> Documents`,
                Model: {},
                Schema: {}
            }
        ]
    }
    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        Parameters.Desc = Documents[Parameters.Document]
        Parameters.Logo = Logo[Parameters.Client]
        step1 = await Verification.LoadSchema(1)
        let result = await LoadModel(Parameters)
        return result;
    },
}